import { CopyOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Layout, Row, Tooltip, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import rfsTheme from '../../theme';
import routes from '../App/routes';
import BackButton from '../BackButton';
import { Optional } from '../Shared';

const { Header } = Layout;

const { Title } = Typography;

const HeaderSection: React.FC<{
  readonly title: string;
  readonly newTeam?: boolean;
  readonly ion?: string;
  readonly teamId?: string;
  readonly endElement?: JSX.Element;
}> = ({ title, newTeam, ion, teamId, endElement }) => {
  const navigate = useNavigate();

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <BackButton />
        <Optional show={endElement !== undefined}>{endElement}</Optional>
      </div>
      <Header
        className="page-header"
        style={{
          padding: 0,
          position: 'sticky',
          zIndex: 10,
          top: 0,
          backgroundColor: rfsTheme.bodyBackgroundColour,
          marginBottom: '5px',
        }}
      >
        <Row style={{ alignItems: 'center' }}>
          <Col span={24} style={{ textAlign: 'center' }}>
            <Title
              level={2}
              ellipsis={{
                rows: 1,
                tooltip: title,
              }}
            >
              {title}
            </Title>
          </Col>
        </Row>
        {ion !== undefined && teamId !== undefined ? (
          <Row
            justify="end"
            style={{ marginTop: '-3rem' }}
            id={`team-${teamId}-io-number`}
          >
            <Col span={10} style={{ textAlign: 'end' }}>
              <span style={{ fontWeight: 'bold' }}>IO Number:</span>{' '}
              <em>{ion}</em>
            </Col>
            <Col span={2}>
              <Tooltip title="Copy IO Number to clipboard">
                <Button
                  style={{
                    background: 'transparent',
                    border: 'transparent',
                    paddingLeft: '0.25rem',
                  }}
                  aria-label={'Copy IO Number to clipboard'}
                  onClick={() => void navigator.clipboard.writeText(ion)}
                >
                  <CopyOutlined />
                </Button>
              </Tooltip>
            </Col>
          </Row>
        ) : undefined}
        <Divider style={{ margin: '5px 0 0' }} />
      </Header>
      <Row justify="end">
        <Col span={24}>
          <Optional show={newTeam ?? false}>
            <Tooltip title="New Team">
              <Button
                style={{
                  float: 'right',
                  background: 'transparent',
                }}
                onClick={() => navigate(routes.newTeam)}
              >
                <UsergroupAddOutlined />
                New Team
              </Button>
            </Tooltip>
          </Optional>
        </Col>
      </Row>
    </>
  );
};

export default HeaderSection;
